<div class="avatar-container" [class]="'avatar-' + size" [class.border]="showBorder" [style.border-color]="showBorder ? borderColor : ''">
  <!-- Image display -->
  <img *ngIf="hasImage" [src]="imageUrl" [alt]="alt" class="avatar-image" (error)="onImageError()" />

  <!-- Placeholder display -->
  <div *ngIf="!hasImage" class="avatar-placeholder">
    <span class="placeholder-text">{{ displayText }}</span>
  </div>
</div>
